import { useState, useRef, useEffect } from "react";
import makeStyles from '@mui/styles/makeStyles';

//components
import { Avatar } from "@mui/material";
import { Slider, Grid } from "@mui/material";
import RightPanel from "components/RightPanel";
import GlassMagnifier from "components/MagnifierGlass/GlassMagnifier";
import Dialpad from "components/Dialpad/Dialpad";

//assets
import freqSlider from "assets/phase2/79.png";
// import langButtonEn from "assets/phase2/70.png";
// import langButtonFa from "assets/phase4/fa.png";

import langButtonFa from "assets/phase9/FaButton.png";
import langButtonEn from "assets/phase9/EngButton.png";
import spaceshipButton from "assets/phase9/spaceshipButton.png";

import safeKnobImage from "assets/phase4/safe.png";
import fingerstopImage from "assets/phase7/fingerstop.png";

import ENkeyboardBaseImage from "assets/phase8/en_keyboard_500.png";
import ENkeyboardLargeImage from "assets/phase8/en_keyboard_1000.png";

import FAKeyboardBaseImage from "assets/phase8/fa_keyboard_500.png";
import FAKeyboardLargeImage from "assets/phase8/fa_keyboard_1000.png";

//helpers
import { getComputedValue } from "utils";

const useStyles = makeStyles((theme) => ({
  smallButtons: {
    height: "100%",
    marginRight: "1vw",
    marginLeft: "1vw",
  },
}));

const freqMarks = [
  {
    value: 0,
    // label: "Family",
  },
  {
    value: 16.66666,
    // label: "OFFICIAL",
  },
  {
    value: 16.66666 * 2 + 0.1,
    // label: "ORIGINAL",
  },
  {
    value: 16.66666 * 3 - 0.3,
    // label: "DIRTY",
  },
  {
    value: 16.66666 * 4,
    // label: "CHAT",
  },
  {
    value: 16.66666 * 5 - 0.19,
    // label: "PRIVATE",
  },
  {
    value: 100 - 0.1,
    // label: "*",
  },
];

const keyboardBaseImages = {
  Fa: FAKeyboardBaseImage,
  En: ENkeyboardBaseImage,
};
const keyboardLargeImages = {
  Fa: FAKeyboardLargeImage,
  En: ENkeyboardLargeImage,
};

function RightContainer({
  percentOfHeight,
  percentOfWidth,
  rightContainerRef,
  playState,
  containersHeight,
  setActiveTab,
}) {
  const classes = useStyles();

  const [frequency, setFrequency] = useState("");
  const [password, setPassword] = useState("");
  const [passwordRepeat, setPasswordRepeat] = useState("");
  const [referralCode, setReferralCode] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [currentTypingFocus, setCurrentTypingFocus] = useState("nowhere");
  const [selectedLetter, setSelectedLetter] = useState("");
  const [selectedLang, setSelectedLang] = useState("En");
  const [typeHandler, setTypeHandler] = useState(() => () => {});
  const keyboardRef = useRef(null);

  const typeHandlers = {
    frequency: setFrequency,
    password: setPassword,
    passwordRepeat: setPasswordRepeat,
    referralCode: setReferralCode,
    searchQuery: setSearchQuery,
    nowhere: () => {},
  };
  const resetInputValues = ()=>{
    setFrequency("")
    setPassword("")
    setPasswordRepeat("")
    setReferralCode("")
    setSearchQuery("")
    setCurrentTypingFocus("nowhere")
  }

  useEffect(() => {
    let handler = (selectedLetter) => {
      if (selectedLetter === "DEL") {
        typeHandlers[currentTypingFocus]((value) => value.slice(0, -1));
      } else {
        if (
          currentTypingFocus === "frequency" &&
          isNaN(parseInt(selectedLetter))
        )
          return;
        typeHandlers[currentTypingFocus]((value) => value + selectedLetter);
      }
    };
    setTypeHandler(() => handler);
    // console.log("handler has been changed to: ", handler);
  }, [currentTypingFocus]);

  return (
    <Grid
      container
      direction="column"
      style={{
        height: "100%",
        width: "100%",
      }}
    >
      <Grid item style={{ height: "13%", width: "100%" }}>
        <div
          style={{
            height: "60%",
            top: "23%",
            width: "38.4%",
            position: "relative",
            left: "46.39%",
            borderRadius: "11% 11% 0% 0%",
          }}
        >
          <Slider
            sx={{
              color: "#00000000",
              "& .MuiSlider-thumb": {
                backgroundImage: `url(${freqSlider})`,
                backgroundSize: "auto 100%",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                stroke: 0,
                boxShadow: "none",
                width: "20%",
                height: "80%",
                borderRadius: 0,
                "::before": {
                  boxShadow: "none",
                },
              },
            }}
            min={0}
            max={100}
            defaultValue={0}
            marks={freqMarks}
            step={null}
          />
        </div>
      </Grid>
      <Grid
        item
        style={{ height: "19%", paddingBottom: "1%", paddingTop: "2%" }}
      >
        <RightPanel
          frequency={frequency}
          password={password}
          passwordRepeat={passwordRepeat}
          referralCode={referralCode}
          searchQuery={searchQuery}
          currentTypingFocus={currentTypingFocus}
          setActiveTab={setActiveTab}
          setCurrentTypingFocus={setCurrentTypingFocus}
          resetInputValues={resetInputValues}
        />
      </Grid>
      <Grid
        item
        style={{
          height: "63%",
          width: "100%",
          paddingRight: "4%",
          paddingLeft: "3%",
          position: "relative",
        }}
      >
        <GlassMagnifier
          ref={keyboardRef}
          imageSrc={keyboardBaseImages[selectedLang]}
          imageAlt="Example"
          largeImageSrc={keyboardLargeImages[selectedLang]} // Optional
          magnifierSize="20%"
          lang={selectedLang}
          style={{
            height: "100%",
            display: "inline",
          }}
          callback={typeHandler}
        />

        <Dialpad
          canvasSize={parseInt(percentOfWidth(53).slice(0, -2)) || 150}
          circlesFillColor={"#555555"}
          circlesStrokeColor={"black"}
          circlesHighlighFillColor={"black"}
          style={{
            zIndex: 100,
            top: "23%",
            left: percentOfWidth(23),
            position: "absolute",
            borderRadius: "50%",
          }}
          callback={typeHandler}
        ></Dialpad>
        <div
          style={{
            width: "22%",
            height: "24%",
            position: "absolute",
            backgroundSize: "100% auto",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",

            backgroundImage: `url(${safeKnobImage})`,
            position: "relative",
            top: " -65%",
            left: "39%",
          }}
        >
          &nbsp;
        </div>
        <div
          style={{
            width: "13.3%",
            height: "10%",
            position: "absolute",
            backgroundSize: "100% auto",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",

            backgroundImage: `url(${fingerstopImage})`,
            position: "relative",
            top: " -82%",
            left: "64%",
            zIndex:10000,
            pointerEvents:"none"
          }}
          // onDrag={}
        >
          &nbsp;
        </div>
      </Grid>
      <Grid item style={{ height: "4%" }}>
        <Grid container spacing={1} style={{ height: "100%", width: "100%" }}>
        <Grid item xs={1}>
            <Avatar
              className={classes.smallButtons}
              style={{
                width: getComputedValue(containersHeight, 5.5),
                height: getComputedValue(containersHeight, 5.5),
                marginLeft: "20%",
              }}
              onClick={() => {
                // setSelectedLang("Fa");
                window.location.href = "https://app.tltimeline.ir "
              }}
              src={spaceshipButton}
            ></Avatar>
          </Grid>

          <Grid item xs={1}>
            <Avatar
              className={classes.smallButtons}
              style={{
                width: getComputedValue(containersHeight, 5.5),
                height: getComputedValue(containersHeight, 5.5),
                marginLeft: "40%"
              }}
              onClick={() => {
                setSelectedLang("En");
              }}
              src={langButtonEn}
            ></Avatar>
          </Grid>
          <Grid item xs={1}>
            <Avatar
              className={classes.smallButtons}
              style={{
                width: getComputedValue(containersHeight, 5.5),
                height: getComputedValue(containersHeight, 5.5),
                marginLeft: "60%"
              }}
              onClick={() => {
                setSelectedLang("Fa");
              }}
              src={langButtonFa}
            ></Avatar>
          </Grid>


          <Grid item xs={4}>
            &nbsp;
          </Grid>
          <Grid item xs={3}>
            &nbsp;
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default RightContainer;
